import { View, Text, StyleSheet } from 'react-native';
import React, { useContext } from 'react';
import _ from 'lodash';
import { Font } from '../types';
import { ThemeContext } from '../contexts/ThemeContext';
import { Divider } from 'react-native-paper';
import { TogglePopUp } from '../toggle-pop-up/toggle-pop-up';
import { InfoTooltip } from '../info-tooltip/info-tooltip';
import { I18nNamespace } from '@zonofi/i18n';

export interface DetailsItemProps {
  heading?: string;
  value?: string | number | JSX.Element;
  list?: JSX.Element;
  headingFont?: Font;
  valueFont?: Font;
  textColor?: string;
  headingFontSize?: number;
  valueFontSize?: number;
  headingColor?: string;
  padding?: boolean;
  underline?: boolean;
  horizontalLine?: boolean;
  valueTextId?: string;
  fullAmount?: string;
  marginVertical?: number;
  ellipsisEnabled?: boolean;
  tooltip?: {
    path: string[];
    dataKey: string;
    namespace: I18nNamespace;
  };
}

const truncateText = (
  text: string,
  maxLength: number,
  ellipsisEnabled: boolean
) => {
  if (ellipsisEnabled && text.length > maxLength) {
    return text.substring(0, maxLength) + '...';
  }
  return text;
};

export const DetailsItem: React.FC<DetailsItemProps> = ({
  heading,
  value,
  list,
  headingFont,
  valueFont,
  textColor,
  headingFontSize,
  valueFontSize,
  headingColor,
  padding,
  underline = false,
  horizontalLine = false,
  marginVertical,
  valueTextId,
  fullAmount,
  ellipsisEnabled = false,
  tooltip,
}) => {
  const currentTheme = useContext(ThemeContext);
  const { theme } = currentTheme;

  return (
    <>
      <View
        style={[
          styles.container,
          {
            marginVertical: marginVertical ?? (padding ? 8 : 8),
            flex: 1,
          },
        ]}
      >
        {heading && (
          <View style={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}>
            <Text
              style={[
                headingFont ?? theme.fontConfig.regular,
                {
                  color: '#8C8C8C',
                  paddingBottom: padding ? 0 : 4,
                  fontSize: headingFontSize ?? 12,
                },
              ]}
            >
              {truncateText(heading, 15, ellipsisEnabled)}
            </Text>
            {tooltip && (
              <InfoTooltip
                namespace={tooltip.namespace}
                path={tooltip.path}
                title={tooltip.dataKey}
              />
            )}
          </View>
        )}

        {!_.isNull(value) || !_.isUndefined(value) ? (
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              zIndex: 'auto' as any,
            }}
          >
            <div
              style={{
                ...(valueFont ?? theme.fontConfig.regular),
                color: textColor ?? theme.text.primary,
                fontSize: valueFontSize ?? 14,
                textDecorationLine: underline ? 'underline' : 'none',
              }}
              id={valueTextId}
              title={
                ellipsisEnabled &&
                typeof value === 'string' &&
                value.length > 15
                  ? value
                  : undefined
              }
            >
              {typeof value === 'string'
                ? truncateText(value, 15, ellipsisEnabled)
                : value}
            </div>
            <TogglePopUp heading={heading} value={fullAmount} />
          </View>
        ) : null}
        {list && <View>{list}</View>}
      </View>
      {horizontalLine && (
        <Divider
          style={{
            backgroundColor: '#DFE0E0',
            height: 48,
            width: 1,
            marginHorizontal: 4,
            marginLeft: '34%',
          }}
        />
      )}
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    marginHorizontal: 10,
    marginLeft: 0,
  },
});
export default DetailsItem;
